import jwtDecode from 'jwt-decode';

const isValidTokenMember = () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return false;
    const decodedToken = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;
    if (
        decodedToken.exp > currentTime &&
        (localStorage.getItem('role') === 'member' ||
            localStorage.getItem('role') === 'admin')
    ) {
        return true;
    }
    return false;
};

export default isValidTokenMember;
